export const environment = {
    production: false,
    apiBaseUrl: 'https://dev.api.getyusr.com/api/v1',
    adminApiBaseUrl: 'https://dev.api.getyusr.com/admin/api/v1',
    appVersion: 'v0.0.5'
  };
